import React, {Component} from "react";
import PrintView from "./PrintView";
import GroupedDateListView from "../../components/listViews/GroupedDateListView";
import DateHelper from "../../components/DateHelper";
import AppointmentService from "../../api/services/AppointmentService";
import {Button, SelectList} from "../../components/FormUI";
import moment from "moment";
import {ClinicDoctors} from "../../components/DataSelectList";
import AccountService from "../../api/services/AccountService";
import './AppPrintView.css';
import ClinicService from "../../api/services/ClinicService";

const appService = new AppointmentService();
const acc = new AccountService();

export default class AppPrintView extends Component {

	/*state = { list: [], userId: acc.userId, name: acc.fullName }
	printView = null;

	componentDidMount() {
		this.handleRangeChange(this.rangeOptions[0]);
	}

	getList = (range) => {
		//let range = this.getSearchRange(duration);
		return this.props.appData;

		let options = {
			StartDate: DateHelper.dateToString(range[0]),
			EndDate: DateHelper.dateToString(range[1])
		}
		this.setState({isBusy: true})
		appService.search(options).then((results) => {
			this.setState({isBusy: false, list: results || []});
		})
	}


	rangeOptions = [
		{label: 'This Week', value: 'this week'},
		{label: 'Next Week', value: 'next week'},
		{label: 'Last Week', value: 'last week'},
		{label: 'This Month', value: 'this month'},
		{label: 'Last 3 Months', value: '3 months'}
	]

	handleRangeChange = (range) => {
		console.log("Range:", range);
		if (!range) return;
		let duration = moment.duration(1, 'week');
		let r = [];
		switch (range.value) {
		case 'this week':
			r = DateHelper.GetWeekRange();
			break;
		case 'next week':
			let nweekStart = moment().add(1, 'week').startOf('week');
			let nweekEnd = nweekStart.clone().endOf('week');
			r = [nweekStart, nweekEnd];
			break;
		case 'last week':
			let weekStart = moment().subtract(1, 'week').startOf('week');
			let weekEnd = moment().endOf('day');
			r = [weekStart, weekEnd];
			break;
		case 'this month':
			r = [moment().startOf('month'), moment().endOf('month')];
			break;
		case '3 months':
			let monthsAgo = moment().startOf('month').subtract(3, 'months').startOf('month');
			r = [monthsAgo, moment().endOf('week')];
			break;
		}

		console.log("NoShow Range:", r[0].toString() + ' - ' + r[1].toString());

		this.getList(r);
	}

	handleUserChange = (userId, name) => {
		this.setState({userId: userId, name: name});
	}

	handleRef = (pview) => {
		this.printView = pview;
	}*/

	print = () => {
		console.log('Print View:', this.printView);
		this.printView.print();
	}

	render(){
		/*const list = this.state.list.filter((app) => {
			return app.userId === this.state.userId;
		})*/

		const appGroup = [];
		const userGroup = {};
		const apps = this.props.appData;

		for(let i=0; i < apps.length; i++){
			const app = apps[i];
			if(!userGroup[app.userId]) {
				userGroup[app.userId] = [];
			}
			userGroup[app.userId].push(app);
		}

		for(let userId in userGroup) {
			const userApps = userGroup[userId];
			const user = ClinicService.GetDrById(userId);
			appGroup.push(<GroupedDateListView apps={userApps} headerSuffix={` - ${user.fullName} @ ${acc.clinicName}`} />)
		}

		let canPrint = true;
		if(appGroup.length < 1) {
			canPrint = false;
			appGroup.push(<div className='nothing'>Nothing to print</div>);
		}

		return (
			<div className={'app-print-view'}>
				<div className={'print-view-controls'}>
					{/*<SelectList placeholder='Select Time Frame' options={this.rangeOptions} onChange={this.handleRangeChange} isLoading={this.state.isBusy} value={this.rangeOptions[0]} />
					<ClinicDoctors onChange={ this.handleUserChange } />*/}
					<span className='close-btn' onClick={this.props.onRequestClose}>Close</span>
				</div>

				<PrintView disabled={!canPrint}>
					{/*<GroupedDateListView apps={this.props.appData} headerSuffix={` - ${this.state.name} @ ${acc.clinicName}`} />*/}
					{appGroup}
				</PrintView>
			</div>

		)
	}
}



// WEBPACK FOOTER //
// ./src/views/print/AppPrintView.jsx